
import {
    UPDATE_DATAROOM_SUCCESS,
  } from '../actions/types';
  
  const INITIAL_STATE = {
    dataroom: null,
  };
  
  export default function dataroomReducer (state=INITIAL_STATE, action) {
    switch (action.type) {
      case UPDATE_DATAROOM_SUCCESS:
        return { ...state, dataroom: action.payload.dataroom };
      default:
        return state;
    }
  };